import { render, staticRenderFns } from "./FoldersNav.vue?vue&type=template&id=4046e758&"
import script from "./FoldersNav.vue?vue&type=script&lang=js&"
export * from "./FoldersNav.vue?vue&type=script&lang=js&"
import style0 from "./FoldersNav.vue?vue&type=style&index=0&id=4046e758&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports